import { render, staticRenderFns } from "./SpaceshipPreview.vue?vue&type=template&id=1164cd01&scoped=true"
import script from "./SpaceshipPreview.vue?vue&type=script&lang=js"
export * from "./SpaceshipPreview.vue?vue&type=script&lang=js"
import style0 from "./SpaceshipPreview.vue?vue&type=style&index=0&id=1164cd01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1164cd01",
  null
  
)

export default component.exports